import { render, staticRenderFns } from "./SelectCommon.vue?vue&type=template&id=b5556654&scoped=true&"
import script from "./SelectCommon.vue?vue&type=script&lang=js&"
export * from "./SelectCommon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5556654",
  null
  
)

export default component.exports